// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14b01494","455":"d14de69c","977":"6c4b9738"}[chunkId] + ".chunk.js";
};